class ProgramFilterDescriptionUpdater {
	constructor() {
		console.log('ProgramFilterDescriptionUpdater initialized');
		this.bindEvents();
		this.onFilterChange();
	}

	bindEvents() {
		console.log('Binding events for ProgramFilterDescriptionUpdater');
		document.addEventListener('almFilterComplete', this.onFilterChange);
		window.addEventListener('popstate', this.onFilterChange);

		const originalPushState = history.pushState;
		history.pushState = function (...args) {
			originalPushState.apply(this, args);
			window.dispatchEvent(new Event('popstate'));
		};
	}

	onFilterChange = () => {
		console.log('Filter change detected');
		const params = new URLSearchParams(window.location.search);
		const termSlug = params.get('_program-category');

		if (!termSlug) {
			const existingInfo = document.querySelector('.program__filter-info');
			if (existingInfo) {
				existingInfo.remove();
			}
			return;
		}

		fetch(`/wp-json/wp/v2/program-category?slug=${termSlug}`)
			.then(res => res.json())
			.then(data => {
				if (!data.length) return;
				const term = data[0];

				this.updateDescription(term?.name, term?.description, term?.program_category_acf?.program_category_links_group_title, term?.program_category_acf?.program_category_links_repeater);
			});
	};

	updateDescription(name, description, linksGroupTitle, links) {
		const titleEl = document.querySelector('.program__filter-info-title');
		const descEl = document.querySelector('.program__filter-info-description');
		const linksTitleEl = document.querySelector('.program__filter-info-links-title');
		const linksEl = document.querySelector('.program__filter-info-links');

		if (titleEl && descEl && linksTitleEl && linksEl) {
			titleEl.textContent = name;
			descEl.textContent = description;
			linksTitleEl.textContent = linksGroupTitle || '';
			linksEl.innerHTML = Array.isArray(links) && links.length ? links.map(link => {
				const url = link?.link?.url || '';
				const title = link?.link?.title || '';
				return url && title ? `<a href="${url}" class="button button--secondary">${title}</a>` : '';
			}).join('') : '';
		} else {
			if (!name && !description && !linksGroupTitle && (!Array.isArray(links) || !links.length)) {
				return;
			}
			const existingInfo = document.querySelector('.program__filter-info');
			if (existingInfo) existingInfo.remove();

			const container = document.createElement('div');
			container.className = 'row program__filter-info';
			container.innerHTML = `
				<div class="columns small-12 medium-7">
					<h2 class="program__filter-info-title">${name}</h2>
					<p class="program__filter-info-description">${description}</p>
				</div>
				<div class="columns small-12 medium-3">
					${linksGroupTitle ? `<h3 class="program__filter-info-links-title">${linksGroupTitle}</h3>` : ''}
					<div class="program__filter-info-links">
						${Array.isArray(links) && links.length ? links.map(link => {
							const url = link?.link?.url || '';
							const title = link?.link?.title || '';
							return url && title ? `<a href="${url}" class="button button--secondary">${title}</a>` : '';
						}).join('') : ''}
					</div>
				</div>
			`;
			const target = document.querySelector('.program__programs-row');
			if (target) {
				target.insertAdjacentElement('beforebegin', container);
			}
		}
	}
}


export default ProgramFilterDescriptionUpdater;
